import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';

const DetailTable = ({
  items = [],
  sx = {}
}) => {
  return /*#__PURE__*/React.createElement(TableContainer, {
    sx: {
      ...sx
    }
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "simple table"
  }, /*#__PURE__*/React.createElement(TableBody, null, items.map(item => /*#__PURE__*/React.createElement(TableRow, {
    hover: true,
    key: item.key
  }, /*#__PURE__*/React.createElement(TableCell, {
    component: "th",
    scope: "row"
  }, item.key), /*#__PURE__*/React.createElement(TableCell, {
    sx: item.sx
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    fontWeight: "bold"
  }, item.value)))))));
};

export { DetailTable };
